import { Typography } from "@appsflyer/fe-ui-core";
import { Trans, useTranslation } from "react-i18next";
import { ISessionProps } from "../../../main/components/IProgress";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Container, Button } from "@mui/material";
import transition from "../../../main/components/transition";
import { useEffect, useState } from "react";
import { amplitudeTrack_continue } from "../../../services/utils";
import { DJSimpleCodeBlock } from "../../../main/components/codeblock";

const DL_prepareUniversalLinks2ReactNative = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [extractedDomain, setExtractedDomain] = useState("");
  const [appId, setAppId] = useState<string>("");
  const [code, setCode] = useState("");

  useEffect(() => {
    const oneLinkURL_ls = localStorage.getItem(
      `oneLinkURL_${location.state?.os}_${location.state?.appID}`
    );
    if (oneLinkURL_ls) {
      const parsedOneLink = JSON.parse(oneLinkURL_ls).replaceAll(`"`, ``);
      const newSubdomain = parsedOneLink?.startsWith("http")
        ? new URL(parsedOneLink).hostname
        : new URL("http://" + parsedOneLink).hostname;
      setExtractedDomain(newSubdomain);
    } else if (location.state?.oneLinkURL) {
      const onelink: URL = new URL(
        location.state.oneLinkURL.indexOf("http") > -1
          ? location.state.oneLinkURL
          : "https://" + location.state.oneLinkURL
      );
      setExtractedDomain(onelink.host);
    }
  }, []);

  useEffect(() => {
    if (location.state) {
      const state: ISessionProps = location.state as ISessionProps;
      setAppId(state?.appID ?? "");
    }
  }, [location.state]);

  useEffect(() => {
    if (extractedDomain && appId) {
      const codeBlockContent = `{
  "expo": {
    ...
    "plugins": [
      [
        "react-native-appsflyer",
        {}
      ],
      [
        "./custom_plugins/withNoBitcode"
      ],
      [
        "expo-tracking-transparency",
        {
          "userTrackingPermission": "Allowing app tracking will improve the customization of ads"
        }
      ]
    ],
    "scheme": "",
    "ios": {
      "bitcode": false,
      "supportsTablet": true,
      "bundleIdentifier": "", // Replace with your bundle ID (e.g., "com.example.app")
      "associatedDomains": ["applinks:${extractedDomain}"]
    },
    "web": {
      "favicon": "./assets/favicon.png"
    }
  }
}`;
      setCode(codeBlockContent);
    }
  }, [extractedDomain, appId]);

  const handleClick = () => {
    const progressState: ISessionProps = {
      ...location.state,
      currentPage: location.state?.currentPage + 1,
    };
    amplitudeTrack_continue(location.state);

    navigate(`/deeplink/${location.state?.os}/prepareURI`, { state: progressState });
  };

  return (
    <Container maxWidth={"lg"}>
      <Box padding={3} style={{ minHeight: "50vh" }}>
        <Box marginBottom={2}>
          <Typography variant="h1">{t("dl_6_ios_prepare_app")}</Typography>
        </Box>

        
        <>
          <Typography>
            <Trans
              i18nKey="dl_prepare_reactnative_ios"
              components={{ code: <code /> }}
            />
          </Typography>

          <br />
          <DJSimpleCodeBlock
            codePrimary={code}
            language="json"
            showLineNumbers={true}
            highlight="1,4-9,10-18,20-25,30"
          />
        </>
      </Box>
      <Box
        display={"flex"}
        width={"100%"}
        justifyContent="space-between"
        alignSelf="end"
        justifySelf="end"
        marginTop={5}
        textAlign="end"
      >
        {" "}
        <Button
          variant="outlined"
          size="medium"
          color="secondary"
          style={{ marginRight: "5px" }}
          onClick={() => navigate(-1)}
        >
          {t("StartSDK_back")}
        </Button>
        <Button
          variant="contained"
          size="medium"
          color="primary"
          onClick={() => handleClick()}
        >
          {t("StartSDK_continue")}
        </Button>
      </Box>
    </Container>
  );
};

export default transition(DL_prepareUniversalLinks2ReactNative);

